import React from "react";
import { StaticIconProps } from "../type";

export const MusicalNote = ({ size = 24 }: StaticIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0575 2.15174C22.0575 1.75424 21.7125 1.45424 21.3225 1.50674L8.595 3.15674C8.2725 3.20174 8.025 3.47924 8.025 3.80924V14.0167C7.5825 13.8667 7.1025 13.7767 6.6075 13.7767C4.2 13.7767 2.25 15.7342 2.25 18.1417C2.25 20.5492 4.2 22.4992 6.6075 22.4992C9.015 22.4992 10.965 20.5492 10.965 18.1417C10.965 18.0517 10.9575 17.9542 10.9575 17.8642V7.43924C10.9575 7.14674 11.175 6.90674 11.46 6.86924L18.4725 5.96174C18.8175 5.91674 19.125 6.18674 19.125 6.53174V11.4292C18.675 11.2717 18.195 11.1892 17.7 11.1892C15.2925 11.1892 13.3425 13.1392 13.3425 15.5467C13.3425 17.9542 15.2925 19.9042 17.7 19.9042C20.1075 19.9042 22.0575 17.9542 22.0575 15.5467C22.0575 15.5392 22.0575 15.5392 22.0575 15.5317V2.15174Z"
        fill="#402A32"
      />
    </svg>
  );
};
